class Accordion {
  constructor() {
    this.selectors = {
      button: '.accordion__trigger',
      buttonNotExpandedOnLOad: '.accordion__trigger[aria-expanded="false"]',
      panel: '.accordion__panel',
    };
  }

  // accessibility
  handleAccordionDisplay() {
    $(this.selectors.buttonNotExpandedOnLOad).each((index, element) => {
      const buttonId = $(element).attr('id');
      const panel = $(`.accordion__panel[aria-labelledby="${buttonId}"]`);
      panel.hide();
    });
  }

  accordionItemToggle() {
    $(this.selectors.button).on('click', (e) => {
      const buttonId = $(e.currentTarget).attr('id');
      const panel = $(`.accordion__panel[aria-labelledby="${buttonId}"]`);
      const isExpanded = $(e.currentTarget).attr('aria-expanded');
      panel.slideToggle();
      /* eslint no-unused-expressions:
      ["error", { "allowShortCircuit": true, "allowTernary": true }] */
      isExpanded === 'true'
        ? $(e.currentTarget).attr('aria-expanded', 'false')
        : $(e.currentTarget).attr('aria-expanded', 'true');
    });
  }

  init() {
    this.handleAccordionDisplay();
    this.accordionItemToggle();
  }
}

export default new Accordion();
